/**
 * @file index
 * @author imcuttle <moyuyc95@gmail.com>
 * @date 2018/11/6
 *
 */

module.exports = require('./CopyEnvInfo')
